module.exports = __webpack_public_path__ + "img/q3.a61b683a.png";